import type { Category } from '@/types/content';

export const categories: Category[] = [
  {
    slug: 'celebrities',
    name: '明星动态',
    description: '聚焦演艺圈台前幕后的行程、合作与新动向，用理性视角还原事件脉络。',
    icon: 'ri-user-star-line',
    count: 128,
    accent: 'primary',
  },
  {
    slug: 'variety',
    name: '综艺热点',
    description: '追踪热播综艺的名场面、赛制变化与嘉宾表现，第一时间整理讨论焦点。',
    icon: 'ri-live-line',
    count: 96,
    accent: 'accent',
  },
  {
    slug: 'film-tv',
    name: '影视播报',
    description: '新剧开播、票房走势、口碑分化，把碎片化的信息拼成完整的故事线。',
    icon: 'ri-film-line',
    count: 142,
    accent: 'secondary',
  },
  {
    slug: 'influencer',
    name: '网红观察',
    description: '观察内容创作者的流量起落、直播风云与商业合作中的公开争议。',
    icon: 'ri-tv-2-line',
    count: 87,
    accent: 'primary',
  },
  {
    slug: 'buzz',
    name: '网络热议',
    description: '汇总全网高频讨论的话题，梳理不同观点的来龙去脉与最新进展。',
    icon: 'ri-chat-smile-3-line',
    count: 203,
    accent: 'accent',
  },
  {
    slug: 'industry',
    name: '行业风云',
    description: '从宣发、经纪到平台生态，解读娱乐产业里正在发生的结构性变化。',
    icon: 'ri-building-2-line',
    count: 64,
    accent: 'secondary',
  },
];